// extracted by mini-css-extract-plugin
module.exports = {"red":"#db1c1c","green":"#45b562"};